import React, { useEffect, useState } from 'react';
import {
  FaAngleDoubleUp,
  FaAngleDoubleDown,
  FaMapMarkerAlt,
  FaComments,
  FaShare,
  FaCartArrowDown,
} from 'react-icons/fa';
import TOUR_LINK_KEYS from '../constants/OneTour';
import DEPART_DIC from '../constants/DepartDic';
import {
  beautyReefHotelList,
  noWindHotelList,
} from '../constants/EgypetCollectionHotelsList';
import formatNumber from '../utils/formatNumber';
import OneTour from './OneTour';
import GroupedByRoomTours from './GroupedByRoomTours';
import FlightsClock from '../../../shared/components/FlightsClock';
import GeoclientTourButton from '../components/Geoclient/GeoclientTourButton';
import moment from 'moment';
import $ from 'jquery';
import _ from 'underscore';
import { ShareModal } from '../components/ShareModal/ShareModal';
import InExcludedDirections from '../utils/checkInExcludedDirections';
import {
  CURRENCY_CLASSES,
  DEFAULT_CURRENCY_CLASS,
  CREDIT_PERCENT,
  CURRENCY_MAP_ICON,
} from '../constants/CurrencyClasses';
import { TOUR_ROW_MAP } from '../constants/TourRowMap';
import { MEAL_TITLES } from '../constants/MealTitles';
import { TYPE_ROOM_MAP } from '../constants/TypeRoomMap';
import { Link } from 'react-router-dom';
import { AiFillLike } from 'react-icons/ai';
import { LuPlaneTakeoff } from 'react-icons/lu';
import { BsFillLightningChargeFill } from 'react-icons/bs';
import { IoCloseCircle, IoWarning } from 'react-icons/io5';

const OneHotelMobileView = ({
  row,
  departure,
  requestModel,
  geoclient,
  recomend = false,
  onContinue,
  onAction,
  sort,
  onSort,
  getHotelInfo,
  hasGeograftourReviews,
}) => {
  const [isOpen, setOpen] = useState(false);
  const [isOpenModal, setOpenModal] = useState(false);
  const [tourToShare, setTourToShare] = useState(null);
  const [roomList, setRoomList] = useState([]);
  const [groupedTours, setGroupedTours] = useState([]);
  const [toursLength, setToursLength] = useState(0);
  const [isHotelCardHidden, setHotelCardHidden] = useState(false);

  const tourAgencyBaseUrl =
    'https://www.geograftour.com/tours/agency-tour-info/';
  const touroperatorLogoUrl = `https://geograftour.com/static/index/img/touroperator/tourvisor/`;

  const toggleTours = () => {
    setOpen(!isOpen);
  };

  const handleContinue = (e) => {
    $(e.target).hide();
    onContinue();
  };

  const oneTour = (item) => {
    if (
      InExcludedDirections(
        item.operatorcode,
        item.departurecode,
        item.countrycode,
        item.regioncode
      )
    ) {
      return;
    }
    const depart_id = departure;
    const departureName = DEPART_DIC[departure]?.name_from;
    const row = {
      provider: 'tourvisor',
      request_id: '',
      source_id: '',
      hash: '',
      currency_class: 'rouble',
      base_tour: 1,
      depart_id,
      departureName,
    };
    Object.keys(item).forEach((key) => {
      var new_key = TOUR_ROW_MAP[key] || key;
      row[new_key] = item[key] || '';
    });

    row.offer_id = item.tours.tour[0].tourid;
    row.place_id = item.tours.tour[0].placement;
    row.place_name = item.tours.tour[0].placement;
    row.room_id = item.tours.tour[0].room;
    row.room_name = item.tours.tour[0].room;
    row.oper_id = item.tours.tour[0].operatorcode;
    row.oper_name = item.tours.tour[0].operatorname;
    row.price = parseInt(item.price, 10);
    row.hot_price = 0;
    row.child = row.child === '' ? 0 : row.child;
    row.ages = '';
    if (parseInt(row.adult, 10) === 2 && parseInt(row.child, 10) === 0) {
      row.show_half = true;
      row.hot_price = Math.ceil(row.price / 2);
    }
    if (item.tours.tour[0].mealcode === 9067) {
      row.meal_full = 'Питание по программе экскурсионного тура';
    } else {
      row.meal_full = MEAL_TITLES[item.tours.tour[0].meal] || '';
    }
    row.meal_id = item.tours.tour[0].mealcode;
    row.meal_name = item.tours.tour[0].meal;
    row.star_name = row.star_id + '*';

    row.dt1 = item.tours.tour.length
      ? item.tours.tour[0].flydate
      : '25.04.2024';
    row.nights = item.tours.tour[0].nights;
    row.dt2 = moment(row.dt1, 'DD.MM.YYYY')
      .add(parseInt(item.tours.tour[0].nights, 10), 'days')
      .format('DD.MM.YYYY');

    row.volatility = '';
    row.hotel_link = row.hotel_link;
    row.currency_class =
      CURRENCY_CLASSES[item.currency] || DEFAULT_CURRENCY_CLASS;
    row.text = '';
    row.discount = false;

    row.comment = ''; //FindTourComment(item);

    row.full_price = row.price;
    row.credit_price = Math.round(row.full_price * CREDIT_PERCENT, 2);
    row.full_price_label = formatNumber(row.full_price);
    row.hot_price_label = formatNumber(row.hot_price);
    row.credit_price_label = formatNumber(row.credit_price);
    row.claim_mark = 'agency';
    row.credit = false;

    row.promo = /promo|промо/i.test(item.tours.tour[0].tourname) ? 1 : 0;

    row.hotel_adult = item.tours.tour[0].adults;
    row.hotel_child = item.tours.tour[0].child;
    row.adult = requestModel['adults'];
    row.child = requestModel['child'];
    row.ages = Array.isArray(requestModel['ages'])
      ? requestModel['ages'].join(',')
      : '';
    return {
      row: row,
      tour_link: $.param(_.pick(row, TOUR_LINK_KEYS)),
      request_id: '',
      additional: '',
    };
  };

  const parseOneHotelTours = (item) => {
    const hotel = oneTour(item);
    return hotel;
  };

  function groupToursByRoom(tourList) {
    if (tourList.length !== toursLength) {
      setToursLength(tourList.length);
      let roomList = [];
      tourList.forEach((tour) =>
        roomList.includes(tour.room) ? false : roomList.push(tour.room)
      );
      setRoomList(roomList);
      let group = {};
      for (let i = 0; i < tourList.length; i++) {
        let tour = tourList[i];

        if (group.hasOwnProperty(tour.room)) {
          group[tour.room].push(tour);
        } else {
          group[tour.room] = [tour];
        }
      }
      setGroupedTours(group);
    }
  }

  function hideHotelCard() {
    setHotelCardHidden(!isHotelCardHidden);
  }

  useEffect(() => {
    groupToursByRoom(row.tours.tour);
  }, [row.tours.tour]);

  const row_fix = parseOneHotelTours(row);

  const {
    hotelname,
    hotelrating,
    picturelink,
    hotelcode,
    hotelstars,
    countryname,
    regionname,
    tours,
    hoteldescription,
    currency,
  } = row;
  const { departureName } = row_fix.row;

  function textNights(nights) {
    if (nights === 1) {
      return `${nights} ночь`;
    }
    if (nights < 5) {
      return `${nights} ночи`;
    }
    if (nights > 4) {
      return `${nights} ночей`;
    }
  }
  return (
    <>
      <article
        className={`hotel-card_agency ${
          isHotelCardHidden ? 'hotel-card_agency_hidden' : ''
        } ${recomend}`}
      >
        {tourToShare ? (
          <ShareModal
            row={tourToShare}
            open={isOpenModal}
            handleClose={() => {
              setOpenModal(false);
              setTourToShare(null);
            }}
          />
        ) : null}
        <div className="hotel-card__image" id={hotelcode}>
          {hotelrating > 0 && (
            <div
              className="hotel-card__rating hotel-card__rating"
              title="Средний рейтинг отеля"
            >
              {hotelrating > 0 ? parseFloat(hotelrating, 2) : ''}
            </div>
          )}
          <div className={'hotel-card__badges'}>
            {row_fix.row.promo ? (
              <span className="hotel-card__promo-mobile hotel-card__promo-mobile">
                ПРОМО
              </span>
            ) : null}
            {!!recomend ? (
              <div className="tour__geolike tour__badge">
                <AiFillLike />
              </div>
            ) : null}
          </div>
          <img
            className="hotel__image"
            id={hotelcode}
            alt={`Фото отеля ${hotelname}`}
            src={picturelink}
            onClick={() => getHotelInfo(hotelcode)}
            loading="lazy"
          />
          <div className="hotel__social-bar">
            <FaShare
              title={'Поделиться туром'}
              className="hotel__social-btn"
              onClick={() => {
                setOpenModal(true);
              }}
            />
            <FaComments
              onClick={() => getHotelInfo(hotelcode, 3)}
              className="hotel__social-btn"
              title="Отзывы туристов"
            />
            <FaMapMarkerAlt
              onClick={() => getHotelInfo(hotelcode, 1)}
              className="hotel__social-btn"
              title="Отель на карте"
            />
            {!!hasGeograftourReviews ? (
              <div
                className="tour__georeview"
                onClick={() => {
                  getHotelInfo(row.hotelcode, 2);
                }}
                title={`Есть отзывы экспертов на отель ${hotelname}`}
              >
                <img
                  src="https://geograftour.com/static/index/img/geoclient/geo-simple-logo.webp"
                  alt=""
                  loading="lazy"
                />
              </div>
            ) : null}
            <IoCloseCircle
              title="Скрыть данный отель"
              className="hotel-card__close-btn"
              onClick={hideHotelCard}
            ></IoCloseCircle>
          </div>
        </div>
        <div className="hotel-card__body" id={hotelcode}>
          <div className="hotel__short-info">
            <div
              className="hotel__title hotel__title"
              id={hotelcode}
              onClick={(e) => getHotelInfo(e.target.id)}
            >
              {hotelstars > 0 ? <span>{hotelstars}* </span> : null}
              {hotelname}
            </div>
            <span className="hotel-card__region">
              {countryname}, {regionname}
            </span>
            <span className="hotel-card__departure">
              {departureName === 'без перелета' ? (
                <>Без перелета</>
              ) : (
                <>
                  <LuPlaneTakeoff />
                  из {DEPART_DIC[departure]?.name_from}
                </>
              )}
            </span>
            <div className="hotel__badge-feature">
              {row_fix.row.country_id === 1 &&
              beautyReefHotelList.includes(+hotelcode) ? (
                <span style={{ background: '#fc6464' }}>Красивый риф</span>
              ) : null}
              {row_fix.row.country_id === 1 &&
              noWindHotelList.includes(+hotelcode) ? (
                <span style={{ background: '#009abc' }}>Бухта без ветра</span>
              ) : null}
            </div>
            <div className="hotel__tour-flight-info">
              <span style={{ fontSize: '12px' }}>
                С {moment(tours.tour[0].flydate, 'DD.MM.YYYY').format('DD MMM')}
                , на <b>{textNights(tours.tour[0].nights)}</b>
              </span>
              {String(departure) !== '99' ? (
                <>
                  {tours.tour[0].regular === 1 ? (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '3px',
                      }}
                    >
                      <IoWarning className="hotel__tour-flight-info-warning" />
                      Рейс регулярный, возможны доплаты
                      <FlightsClock tour_id={row.tours.tour[0].tourid} />
                    </div>
                  ) : (
                    <>
                      <span className="">Чартер</span>
                      <FlightsClock tour_id={row.tours.tour[0].tourid} />
                    </>
                  )}
                  {tours.tour[0].fuelcharge ? (
                    <div>
                      Включен топливный сбор:{' '}
                      <span>
                        {tours.tour[0].fuelcharge} {tours.tour[0].currency}
                      </span>
                    </div>
                  ) : null}
                </>
              ) : null}
            </div>
            <div className="hotel__room-details-container">
              <div className="hotel__room-details">
                <span>
                  {TYPE_ROOM_MAP[row_fix.row.place_name]
                    ? `${TYPE_ROOM_MAP[row_fix.row.place_name]}`
                    : `${row_fix.row.place_name}`}
                </span>
                <span>
                  {row_fix.row.meal_id === 9067
                    ? row_fix.row.meal_full
                    : `${row_fix.row.meal_name}, ${row_fix.row.meal_full}`}
                </span>
              </div>
              <GeoclientTourButton
                tour={row_fix.row}
                geoclient={geoclient}
                onAction={onAction}
              />
            </div>
          </div>
          <div className="hotel__description">{hoteldescription}</div>
          <div className="hotel__tour">
            <Link
              className="hotel__tour-link"
              target="_blank"
              to={`${tourAgencyBaseUrl}${row.tours.tour[0].tourid}/?currency=${currency}`}
            >
              <FaCartArrowDown className="hotel__tour-link-price-icon" />
              <p className="hotel__tour-link-price">
                {row_fix.row.full_price_label}{' '}
                <small>{CURRENCY_MAP_ICON[currency]}</small>
              </p>
              {row.tours.tour[0].hotelstatus === 2 ? (
                <span className="hotel__tour-link-permanent-booking-container">
                  <BsFillLightningChargeFill
                    className="hotel__tour-link-permanent-booking"
                    title="Мгновенное бронирование"
                  />
                </span>
              ) : null}
            </Link>

            {!requestModel.hideoperator ? (
              <img
                src={`${touroperatorLogoUrl}${row.tours.tour[0].operatorcode}.png`}
                alt={row.tours.tour[0].operatorname}
                className="hotel__operator-logo"
                loading="lazy"
              />
            ) : null}
            <div className="hotel__tour-buttons">
              <button
                type="button"
                onClick={toggleTours}
                className="hotel__open-tours-btn btn"
              >
                {isOpen ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />}
              </button>
            </div>
          </div>
        </div>
      </article>
      {isOpen ? (
        <>
          {row.tours.tour.length && sort === 'price' ? (
            <button
              className="tour__group-button"
              onClick={() => onSort('room')}
            >
              Группировать по типу номера
            </button>
          ) : (
            <button
              className="tour__group-button"
              onClick={() => onSort('price')}
            >
              Группировать по стоимости
            </button>
          )}
        </>
      ) : null}
      {isOpen && sort === 'room' ? (
        <div>
          <GroupedByRoomTours
            row_fix={row_fix}
            row={row}
            groupedTours={groupedTours}
            roomList={roomList}
            hideoperator={requestModel.hideoperator}
            geoclient={geoclient}
            onContinue={handleContinue}
            onAction={onAction}
            setOpenModal={setOpenModal}
            setTourToShare={setTourToShare}
          />
        </div>
      ) : (
        <>
          {isOpen && row.tours.tour.length && (
            <div className="hotel_hidden_list1">
              {row.tours.tour.map((tour) => (
                <OneTour
                  key={tour.tourid}
                  row_fix={row_fix}
                  row={row}
                  hideoperator={requestModel.hideoperator}
                  geoclient={geoclient}
                  onAction={onAction}
                  tour={tour}
                  setOpenModal={setOpenModal}
                  setTourToShare={setTourToShare}
                />
              ))}
              {row.tours.tour.length > 0 ? (
                <div style={{ textAlign: 'center' }}>
                  <button
                    className="btn__search-tour-more"
                    style={{ padding: '5px 10px', fontSize: 12 }}
                    onClick={handleContinue}
                  >
                    Еще туры
                  </button>{' '}
                </div>
              ) : null}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default OneHotelMobileView;
